











































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import { validateEmail } from '@/utils/helpers'
import Icon from '@/components/Icon.vue'
import Input from '@/components/inputs/Input.vue'
import { AuthModule } from '@/store/modules/auth.module'

@Component({
  components: {
    Icon,
    Input
  }
})
export default class ForgotPassword extends Vue {
  authModuleInstance: AuthModule = getModule(AuthModule, this.$store)
  email: string = ''
  isSent: boolean = false
  isEmailValid: boolean = true
  isSendingEmail: boolean = false

  async sendMail () {
    this.isEmailValid = true
    if (!validateEmail(this.email)) {
      this.isEmailValid = false
      return
    }

    this.isSendingEmail = true
    await this.authModuleInstance.forgotPassword(this.email)
    this.isSent = true
    this.isSendingEmail = false
  }
}
